import React from 'react';
import { ContentContainer } from 'web-ui-components/lib/layout/containers';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { VerticalMenu } from 'web-ui-components/lib/navigation/menus';
import { SubBody } from 'web-ui-components/lib/typography/body';
import {
  PAGE_CLAIM_AMOUNT,
  PAGE_DESCRIBE_THE_GOODS,
  PAGE_DESCRIBE_THE_TRAVEL_BOOKING,
  GOODS,
  SERVICES,
  TRAVEL,
  PAGE_DESCRIBE_THE_SERVICE,
} from '../../../constants/FraudAndDisputeConstants';
import { DisputeProgressComponent } from './DisputeProgressComponent';
import FraudAndDisputeActionCreator from '../../../actions/FraudAndDisputeActionCreator';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import config from '../../../config';
import FraudAndDisputeStore from '../../../stores/FraudAndDisputeStore';

export const WhatDidntYouReceive = (props) => {
  const { content, setPage } = props;
  const verticalMenuItems = [
    {
      heading: content.goodsText,
      id: 'goods',
      onClick: () => {
        FraudAndDisputeStore.getDisputeJourneyType() !== GOODS &&
          FraudAndDisputeActionCreator.clearDisputeFormData();
        FraudAndDisputeActionCreator.setDisputeJourneyType(GOODS);
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_dispute_journey_type_goods,
          config.analytics.analytics_action_button_click
        );
        setPage(PAGE_DESCRIBE_THE_GOODS);
      },
      content: <SubBody>{content.goodsSubText}</SubBody>,
    },
    {
      heading: content.travelText,
      id: 'travel',
      onClick: () => {
        FraudAndDisputeStore.getDisputeJourneyType() !== TRAVEL &&
          FraudAndDisputeActionCreator.clearDisputeFormData();
        FraudAndDisputeActionCreator.setDisputeJourneyType(TRAVEL);
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_dispute_journey_type_travel,
          config.analytics.analytics_action_button_click
        );
        setPage(PAGE_DESCRIBE_THE_TRAVEL_BOOKING);
      },
      content: <SubBody>{content.travelSubText}</SubBody>,
    },
    {
      heading: content.servicesText,
      id: 'services',
      onClick: () => {
        FraudAndDisputeStore.getDisputeJourneyType() !== SERVICES &&
          FraudAndDisputeActionCreator.clearDisputeFormData();
        FraudAndDisputeActionCreator.setDisputeJourneyType(SERVICES);
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_dispute_journey_type_services,
          config.analytics.analytics_action_button_click
        );
        setPage(PAGE_DESCRIBE_THE_SERVICE);
      },
      content: <SubBody>{content.servicesSubText}</SubBody>,
    },
  ];
  return (
    <ApplicationFormShell
      leftSidebar={
        <DisputeProgressComponent
          items={content.disputeProgressStepperItems}
          currentId="2"
        />
      }
    >
      <ContentContainer>
        <PageHeading>{content.whatDidntYouReceive}</PageHeading>
        <VerticalMenu items={verticalMenuItems} />
        <div className="dispute-nav-buttons">
          <NavigationButton.Secondary
            labelText={content.back}
            onClick={() => {
              setPage(PAGE_CLAIM_AMOUNT);
            }}
          />
        </div>
      </ContentContainer>
    </ApplicationFormShell>
  );
};
